<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Order History</div>
		</div>
		<div class="mt-2">
			<v-col cols="12" class="px-0 pb-0 pb-sm-3">
				<div class="d-flex justify-end">
					<v-btn depressed color="grey lighten-1" class="mr-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
					<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showSearch">
						<div class="d-flex">
							<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
							<div class="d-none d-sm-block">Search</div>
						</div>
					</v-btn>
				</div>
			</v-col>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-3" v-if="!loading">
					<v-row v-if="transactionList.length > 0">
						<v-col cols="12" class="pt-0">
							<v-data-table hide-default-footer disable-sort :headers="tableHeaders" :items="transactionList" item-key="transaction_id" class="table-vo table-w-sm-120">
								<template v-slot:[`item.action`]="{ item }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn class="" fab dark x-small depressed color="primary" v-bind="attrs" v-on="on" @click.stop="goDetailPO('detail', item.transaction_code)">
												<v-icon dark>mdi-text-box-search</v-icon>
											</v-btn>
										</template>
										<span>Details</span>
									</v-tooltip>
									<v-tooltip bottom v-if="false">
										<template v-slot:activator="{ on, attrs }">
											<v-btn class="ml-1" fab dark x-small depressed color="blue lighten-2" v-bind="attrs" v-on="on" @click="printTransaction(item.transaction_code)">
												<v-icon dark>mdi-printer</v-icon>
											</v-btn>
										</template>
										<span>Print</span>
									</v-tooltip>
									<v-tooltip bottom v-if="item.transaction_status == 'pending'">
										<template v-slot:activator="{ on, attrs }">
											<v-btn class="ml-1" fab dark x-small depressed color="cyan darken-1" v-bind="attrs" v-on="on" @click.stop="goDetailPO('upload', item.transaction_code)">
												<v-icon dark>mdi-credit-card-check</v-icon>
											</v-btn>
										</template>
										<span>Upload Payment Receipt</span>
									</v-tooltip>
								</template>
								<template v-slot:[`item.transaction_datetime`]="{ item }">
									{{ item.transaction_datetime | toDateHour }}
								</template>
								<template v-slot:[`item.transaction_status`]="{ item }">
									<v-chip small :color="item.transaction_status | toColorStatus" class="font-weight-bold white--text text-uppercase">{{ item.transaction_status_formatted}}</v-chip>
								</template>
								<template v-slot:[`item.transaction_total_price`]="{ item }">
									<div class="secondary--text font-weight-bold">{{ item.transaction_total_price | toCurrencyFormat }}</div>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
					<div class="mt-3" v-if="transactionList.length == 0">
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
									<NoData></NoData>
									<div class="px-3 pt-3 text-center secondary--text">No transaction history available.</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
					<div v-if="transactionList.length > 0">
						<v-row justify="end">
							<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
								<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="transactionPagination.total_page" @input="changePage"></v-pagination>
							</v-col>
							<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
								<div class=" font-size-10">Showing {{ transactionPagination.total_display }} data from {{ transactionPagination.total_data }} data</div>
							</v-col>
							<v-col cols="3" sm="2" md="1">
								<v-select :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" item-color="red darken-3" color="primary" @input="changeLimit"></v-select>
							</v-col>
						</v-row>
					</div>
				</div>
			</v-scroll-x-reverse-transition>
			<div class="mt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
		<ModalCari ref="modalCari" @action="cari"></ModalCari>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalCari from './components/ModalCari';

export default {
	components: {
		ModalCari
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
			tabActive: 0,
			tabDisabled: false,
			expanded: [],
			singleExpand: false,
			tableHeaders: [
				{ text: 'Aksi', width: '15%', align: 'start', value: 'action' },
				{ text: 'Invoice No.', width: '12%', align: 'start', value: 'transaction_code' },
				{ text: 'Date', width: '33%', align: 'start', value: 'transaction_datetime' },
				{ text: 'Status', width: '10%', align: 'center', value: 'transaction_status' },
				{ text: 'Total Price(RM)', width: '30%', align: 'end', value: 'transaction_total_price' },
			]
		}
	},
	computed: {
		...mapState('transaksiProduk', ['transactionList', 'transactionPagination']),
	},
	methods: {
		...mapActions('transaksiProduk', ['getTransactionList']),

		getData() {
			this.loading = true
			this.tabDisabled = true
			let params = {
				limit: this.limit,
				page: this.page,
				params: this.params,
				sort: 'transaction_datetime',
				dir: 'DESC'
			}
			this.getTransactionList(this.queryString(params)).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
				this.tabDisabled = false
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		showSearch() {
			this.$refs.modalCari.modalShow()
		},
		goDetailPO(type, code) {
			this.$router.push({ name: 'detail-order', params: { type: type, slug: code } })
		},
		printTransaction(code) {
			let routeData = this.$router.resolve({name: 'print-product-order', params : { slug: code} })
			window.open(routeData.href, '_blank');
		},
		reset() {
			this.params = []
			this.page = 1
			this.$refs.modalCari.reset()
      this.getData()
		},
		cari(data) {
			if(data.code.value)
				this.params.push(data.code)
			if(data.date.value)
				this.params.push(data.date)
			
			let params = {
				limit: this.limit,
				page: 1,
				params: this.params,
				sort: 'transaction_datetime',
				dir: 'DESC'
			}
			this.getTransactionList(this.queryString(params)).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.$refs.modalCari.modalHide()
			})
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Order History`)
		this.getData()
	}
};
</script>